export default "__VITE_ASSET__CSBTIKfj__"